import { IGetGruposAcessoUseCase } from "../../../presentation/useCases/read/get_grupos_acesso_use_case";
import { GrupoAcesso } from "../../models/grupo_acesso";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * GetGruposAcessoUseCase
 */

export class GetGruposAcessoUseCase implements IGetGruposAcessoUseCase {
  private _items: GrupoAcesso[] = [];
  private _itemsCount: number = 0;
  private _pagesCount: number = 0;

  constructor(
    private readonly repository: IAdministracaoRepository,
  ) { }

  async getGruposAcesso(
    page?: number,
    pageSize?: number,
    nome?: string,
    descricao?: string,
    status?: number,
  ): Promise<void> {
    const result = await this.repository.getGruposAcesso(
      page ?? null,
      pageSize ?? null,
      nome ?? null,
      descricao ?? null,
      status ?? null,
    );

    this._items = result.items;
    this._itemsCount = result.totalItems;
    this._pagesCount = result.totalPages;
  }

  get items(): GrupoAcesso[] {
    return this._items;
  }

  get itemsCount(): number {
    return this._itemsCount;
  }

  get pagesCount(): number {
    return this._pagesCount;
  }
}